export const SEARCH_TAGS_DEFAULT_QUERY = 'entityType:tag pageSize:20 cursor:1'
